import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { voidPartnerStaff } from '../../api/partner-staff.ts';

export default function useVoidPartnerStaff(): UseMutationResult<
  string,
  Error,
  string
> {
  return useMutation({ mutationFn: voidPartnerStaff });
}
